import React, { useState } from "react";
import { Offcanvas, Badge, ListGroup } from "react-bootstrap";
import { IntegratedOrder } from "../types";

interface DeliveryLogDrawerProps {
  show: boolean;
  onHide: () => void;
  order: IntegratedOrder | null;
}

const DeliveryLogDrawer: React.FC<DeliveryLogDrawerProps> = ({
  show,
  onHide,
  order,
}) => {
  if (!order) return null;

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          Delivery Logs - Order #ORD-{order.id}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          <strong>Customer:</strong> {order.customer_name} <br />
          <strong>Shipping Status:</strong>{" "}
          <Badge bg="secondary">{order.shipping_status}</Badge>
        </div>

        <h5>Sync History</h5>
        {order.delivery_logs && order.delivery_logs.length > 0 ? (
          <ListGroup variant="flush">
            {order.delivery_logs.map((log) => (
              <ListGroup.Item key={log.id} className="px-0 py-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <Badge
                    bg={
                      log.sync_status === "SUCCESS"
                        ? "success"
                        : log.sync_status === "FAILED"
                        ? "danger"
                        : "warning"
                    }
                  >
                    {log.sync_status}
                  </Badge>
                  <small className="text-muted">
                    {new Date(log.synced_at || log.updated_at).toLocaleString()}
                  </small>
                </div>
                <div>
                  <small>
                    <strong>EVEX Status:</strong> {log.evex_status}
                  </small>
                </div>
                <div>
                  <small className="text-muted">
                    Attempts: {log.attempt_count}
                  </small>
                </div>
                {log.error_message && (
                  <div className="text-danger mt-1 small">
                    Error: {log.error_message}
                  </div>
                )}
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p className="text-muted">No delivery logs available for this order.</p>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default React.memo(DeliveryLogDrawer);
